import React, { useEffect } from "react";
import imag1 from "../../../Images/process_chart_1.svg";
import imag2 from "../../../Images/process_chart_1.svg";
import imag3 from "../../../Images/process_chart_1.svg";
import imag4 from "../../../Images/process_chart_1.svg";
import imag5 from "../../../Images/process_chart_1.svg";

const Generalprocess = () => {
  const [toggle, setToggle] = React.useState(null);

  const generalProcessData = [
    {
      id: 1,
      title: "Discovery",
      color: "#CCE0FF",
      desc: "In our discovery process, we work closely with stakeholders to deeply understand their industry-specific challenges...",
      image: imag1,
    },
    {
      id: 2,
      title: "Estimation & Planning",
      color: "#FFD6CC",
      desc: "We carefully design the software's architecture, prioritize features, and set a clear timeline...",
      image: imag2,
    },
    {
      id: 3,
      title: "Design",
      color: "#E6CCFF",
      desc: "Our design process is iterative, transitioning from the research phase and preliminary wireframes...",
      image: imag3,
    },
    {
      id: 4,
      title: "Development",
      color: "#FFF1CC",
      desc: "Our development process is agile and collaborative, ensuring that your software is built to the highest standards...",
      image: imag4,
    },
    {
      id: 5,
      title: "Post-release support",
      color: "#CCFFEF",
      desc: "Our post-release support is designed to ensure that your software continues to perform optimally...",
      image: imag5,
    },
  ];

  useEffect(() => {
    setToggle(0);
  }, []);

  return (
    <div className="generalprocess-container mainContainer">
      <h1
        style={{
          fontSize: window.innerWidth < 768 ? 20 : 30,
          textAlign: "center",
          paddingTop: "5rem",
          paddingBottom: "2rem",
        }}
      >
        What is the general process?
      </h1>
      <div className="generalprocess-card-container">
        <div className="image-container">
          <img src={generalProcessData[toggle]?.image} alt="Process Image" />
        </div>
        <div className="processdata-card-containersdta">
          {generalProcessData.map((itme, index) => {
            return (
              <div key={index} className="processdata-card">
                <div className="processdata-header" onClick={() => setToggle(index)}>
                  <span
                    className="id-content"
                    style={{ background: toggle === index ? itme.color : null }}
                  >
                    {itme.id}
                  </span>
                  <span className="titledsta">{itme.title}</span>
                </div>
                <div
                  className={`process-desc-content ${toggle === index ? "active" : "deactive"}`}
                  style={{ transition: "all 0.3s ease-in-out" }}
                >
                  <p>{itme.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Generalprocess;
